export default __webpack_public_path__ + "static/media/Reader's Wristbands of the Celestial Hilt.bfd01877.jpg";